import React, {Component} from 'react'
import {addContainer} from '../../api/ShopsApi'
import {StyleSheet, Modal, Image, TextInput, TouchableOpacity, View, ScrollView, Picker} from 'react-native'
import {Button, Text} from 'react-native-elements'
import {widthPercentageToDP as wp, heightPercentageToDP as hp} from 'react-native-responsive-screen'
import {percWidth, percHeight} from '../../api/StyleFuncs'
import {orderFormStyles} from './ContainerForm'
import logo from '../../../assets/midasRed.png'

 



export default class OrderForm extends Component{

  static navigationOptions = {
    title: "AirFreight"
  }
  //static path = "AirFreight"

    constructor(props){
        super(props)
        this.basket = []
        this.state = {
            type: "Air Freight",

            message: {
              subject: 'New Shipping Request:',
              text: 'Hello, \n You have received a new shipping request. Details outlined below',
              html: "not a thing",
            },

            senderName: "",
            senderAddr: "",
            senderCity: "",
            senderState: "",
            senderZip: "",
            senderPhone: "",
            senderEmail: "",

            receiverName: "",
            receiverAddr: "",
            receiverCity: "",
            receiverState: "",
            receiverZip: "",
            receiverPhone: "",
            receiverEmail: "",

            country: "",
            description: "",
            nPieces: "",
            value: "",
            destPort: "",
            clearCost: "",
            hazardous: "",//yes/no dropdown
            insure: "",//yes/no dropdown
            passportNo: "",
            IRSNo: "",
            grimaldi: "",
            sallum: "",
            deliveryPort: "",
            
            disableSubmit: true,
            invalidSenderName: "",
            invalidSenderAddr: "",
            invalidSenderCity: "",
            invalidSenderState: "",
            invalidSenderPhone: "",
            invalidSenderZip: "",
            invalidSenderPhone: "",
            invalidSenderEmail: "",
        }
    }

    onOrderUploaded = () => {
    console.log('order uploaded')
    /*
    //OPEN UP A CONFIRMATION MODAL
    */
  }


  componentDidMount = async () =>{

    this.checkValidity()
    
  }

onSubmitEmail = async() => {
    
      // create reusable transporter object using the default SMTP transport
  let transporter = nodemailer.createTransport({
    host: "smtp.gmail.com",
    port: 465,
    secure: true, // true for 465, false for other ports
    auth: {
      user: "omi.midas@gmail.com", // generated ethereal user
      pass: "Ribbon111", // generated ethereal password
    },
  });

  // send mail with defined transport object
  let info = await transporter.sendMail({
    from: "omi.midas@gmail.com", // sender address
    to: "oyejr@hotmail.com", // list of receivers
    subject: "Hello ✔", // Subject line
    text: "Hello world?", // plain text body
    html: "<b>Hello world?</b>", // html body
  });

  console.log("Message sent: %s", info.messageId);
  // Message sent: <b658f8ca-6296-ccf4-8306-87d57a0b4321@example.com>

  // Preview only available when sending through an Ethereal account
  console.log("Preview URL: %s", nodemailer.getTestMessageUrl(info));
  // Preview URL: https://ethereal.email/message/WaQKMgKddxQDoou...

}


 
  
    

    onProductUploaded = () =>{
      console.log('product stock updated')
      
    }


    asyncForEach = async (array, callback) => {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
      }
    } 


    setMsg = () =>{
      let html = `
      <div>
      <span><b>Type: </b> ${this.state.type}\n</span>
      <br />
      <h2>Sender Details</h2>
      <span><b>Name: </b> ${this.state.senderName}\n</span>
      <span><b>Address: </b> ${this.state.senderAddr}\n</span>
      <span><b>City: </b> ${this.state.senderCity}\n</span>
      <span><b>State: </b> ${this.state.senderState}\n</span>
      <span><b>Zip: </b> ${this.state.senderZip}\n</span>
      <span><b>Phone: </b> ${this.state.senderPhone}\n</span>
      <span><b>E-mail: </b> ${this.state.senderEmail}\n</span>
      <br />
      <h2>Recipient Details</h2>
      <span><b>Name: </b> ${this.state.receiverName}\n</span>
      <span><b>Address: </b> ${this.state.receiverAddr}\n</span>
      <span><b>City: </b> ${this.state.receiverCity}\n</span>
      <span><b>State: </b> ${this.state.receiverState}\n</span>
      <span><b>Zip: </b> ${this.state.receiverZip}\n</span>
      <span><b>Phone: </b> ${this.state.receiverPhone}\n</span>
      <span><b>E-mail: </b> ${this.state.receiverEmail}\n</span>
      <br />
      <h2>Shipment Details </h2>
      <span><b>Description: </b> ${this.state.country}\n</span>
      <span><b>Description: </b> ${this.state.description}\n</span>
      <span><b>No. of Pieces: </b> ${this.state.nPieces}\n</span>
      <span><b>Value: </b> ${this.state.value}\n</span>
      <span><b>Hazardous: </b> ${this.state.hazardous}\n</span>
      <span><b>Insurance: </b> ${this.state.insure}\n</span>
      <span><b>Passport: </b> ${this.state.passportNo}\n</span>
      <span><b>IRS: </b> ${this.state.IRSNo}\n</span>
      <span><b>grimaldi: </b> ${this.state.grimaldi}\n</span>
      <span><b>sallum: </b> ${this.state.sallum}\n</span>
      <span><b>deliveryPort: </b> ${this.state.deliveryPort}\n</span>
      <span><b>deliveryPort: </b> ${this.state.clearCost}\n</span>
      <br />
      
      


    </div>
    `
            
      let message = {
        subject: 'New Shipping Request:' + this.state.type,
        text: 'Hello, \n You have received a new shipping request. Details outlined below',
        html: html,
      }
      //this.setState({messgae: message})
      return message
    }


    onClickSubmit = async () => {
      let msg = this.setMsg()
      var obj = {
        to: 'oyejr@hotmail.com',
        message: msg
      }
      console.log(obj)
      console.log('1\n', msg)
      this.setState({message: msg}, async ()=>{
        
        console.log('2\n', JSON.parse(JSON.stringify(this.state.message)))
        //console.log('2\n', JSON.stringify(this.state.message))
        //console.log('2\n', JSON.parse(this.state.message))
        
        
        alert("Your request is being submitted \n please wait...")

        try{
          console.log('before')
          //await addContainer(obj, this.onOrderUploaded)
          await addContainer(JSON.parse(JSON.stringify(this.state)), this.onOrderUploaded)
          
          console.log('after')

          alert("Your request has been submitted.\nOur representative will be in contact shortly")
        } catch (error) {
          console.warn(error) 
          alert('Error: please check your internet connection and try again')
        }

        const {navigation} = this.props
        navigation.navigate(
          'Landing Form',
          
        )

    })
      
    }

 
    


    checkValidity = async () => {
      this.state.disableSubmit = false

      if (this.state.senderName === ""){
        this.state.disableSubmit = true
      }
      if (this.state.senderAddr === ""){
        this.state.disableSubmit = true
      }
      if (this.state.senderCity === ""){
        this.state.disableSubmit = true
      }
      if (this.state.senderState === ""){
        this.state.disableSubmit = true
      }
      if (this.state.senderZip === ""){
        this.state.disableSubmit = true
      }
      if (this.state.senderPhone === ""){
        this.state.disableSubmit = true
      }
      if (this.state.senderEmail === ""){
        this.state.disableSubmit = true
      }


      if (this.state.receiverName === ""){
        this.state.disableSubmit = true
      }
      if (this.state.receiverAddr === ""){
        this.state.disableSubmit = true
      }
      if (this.state.receiverCity === ""){
        this.state.disableSubmit = true
      }
      if (this.state.receiverState === ""){
        this.state.disableSubmit = true
      }
      if (this.state.receiverZip === ""){
        this.state.disableSubmit = true
      }
      if (this.state.receiverPhone === ""){
        this.state.disableSubmit = true
      }
      if (this.state.receiverEmail === ""){
        this.state.disableSubmit = true
      }

      if (this.state.country === ""){
        this.state.disableSubmit = true
      }


      if (this.state.description === ""){
        this.state.disableSubmit = true
      }
      if (this.state.nPieces === ""){
        this.state.disableSubmit = true
      }
      if (this.state.value === ""){
        this.state.disableSubmit = true
      }
      if (this.state.hazardous === ""){
        this.state.disableSubmit = true
      }
      if (this.state.insure === ""){
        this.state.disableSubmit = true
      }
      if (this.state.passportNo === ""){
        this.state.disableSubmit = true
      }
      if (this.state.IRSNo === ""){
        this.state.disableSubmit = true
      }

      this.setState({forceRefresh: Math.floor(Math.random() * 100000000)})
      console.warn(this.state.disableSubmit)

    }
    


    render(){
      return(
          <ScrollView style = {orderFormStyles.regForm}>
              <View style = {{marginBottom: 100}}>
              <Image source = {logo} style = {orderFormStyles.modalPic} />
              <Text style = {orderFormStyles.headerCenter} >AIR FREIGHT REQUEST FORM</Text>

              <Text style = {orderFormStyles.textInput} >click</Text>
              <Text style = {orderFormStyles.header} >SHIPPER</Text>

              <Text style = {orderFormStyles.subHeader} >Name</Text>
              <TextInput style = {this.state.senderName !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. Ola Townsend"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderName}
                onChangeText={(text) =>{
                  this.setState({ senderName: text})
                  setTimeout(()=>this.checkValidity(),500)
                  }}/>
           

              <Text style = {orderFormStyles.subHeader} >Street Address</Text>  
              <TextInput style = {this.state.senderAddr !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g H123 Charlie street"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderAddr}
                onChangeText={(text) =>{
                   this.setState({ senderAddr: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >City</Text>  
              <TextInput style = {this.state.senderCity !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. New York City"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderCity}
                onChangeText={(text) =>{
                   this.setState({ senderCity: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >State</Text>  
              <TextInput style = {this.state.senderState !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. New York"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderState}
                onChangeText={(text) =>{
                   this.setState({ senderState: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >Zip Code</Text>  
              <TextInput style = {this.state.senderZip !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. 123456"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderZip}
                onChangeText={(text) =>{
                   this.setState({ senderZip: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >Phone Number</Text>  
              <TextInput style = {this.state.senderPhone !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g +1(456)5678910"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderPhone}
                onChangeText={(text) =>{
                  this.setState({ senderPhone: text})
                  setTimeout(()=>this.checkValidity(),500)
                  }}/>

              <Text style = {orderFormStyles.subHeader} >Email</Text>  
              <TextInput style = {this.state.senderEmail !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. sender@gmail.com"}
                underlineColorAndroid= {'transparent'}
                value={this.state.senderEmail}
                onChangeText={(text) =>{
                   this.setState({ senderEmail: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>          


              </View>




              <View style = {{marginBottom: 100}}>
              <Text style = {orderFormStyles.header} >RECEIVER</Text>

              <Text style = {orderFormStyles.subHeader} >Name</Text>
              <TextInput style = {this.state.receiverName !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. Ola Townsend"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverName}
                onChangeText={(text) =>{
                  this.setState({ receiverName: text})
                  setTimeout(()=>this.checkValidity(),500)
                  }}/>
           

              <Text style = {orderFormStyles.subHeader} >Street Address</Text>  
              <TextInput style = {this.state.receiverAddr !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g H123 Charlie street"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverAddr}
                onChangeText={(text) =>{
                   this.setState({ receiverAddr: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >City</Text>  
              <TextInput style = {this.state.receiverCity !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. New York City"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverCity}
                onChangeText={(text) =>{
                   this.setState({ receiverCity: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >State</Text>  
              <TextInput style = {this.state.receiverState !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. New York"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverState}
                onChangeText={(text) =>{
                   this.setState({ receiverState: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >Zip Code</Text>  
              <TextInput style = {this.state.receiverZip !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. 123456"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverZip}
                onChangeText={(text) =>{
                   this.setState({ receiverZip: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >Phone Number</Text>  
              <TextInput style = {this.state.receiverPhone !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g +1(456)5678910"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverPhone}
                onChangeText={(text) =>{
                  this.setState({ receiverPhone: text})
                  setTimeout(()=>this.checkValidity(),500)
                  }}/>

              <Text style = {orderFormStyles.subHeader} >Email</Text>  
              <TextInput style = {this.state.receiverEmail !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"e.g. receiver@gmail.com"}
                underlineColorAndroid= {'transparent'}
                value={this.state.receiverEmail}
                onChangeText={(text) =>{
                   this.setState({ receiverEmail: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>          


              </View>

              <View style = {{marginBottom: 300}}>
              <Text style = {orderFormStyles.header} >SHIPMENT DETAILS</Text>

              <Text style = {orderFormStyles.subHeader} >Take-off Country</Text>
              <TextInput style = {this.state.country !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {"United States of America"}
                underlineColorAndroid= {'transparent'}
                value={this.state.country}
                onChangeText={(text) =>{
                  this.setState({ country: text})
                  setTimeout(()=>this.checkValidity(),500)
                  }}/>

              <Text style = {orderFormStyles.subHeader} >Description of Item</Text>
              <TextInput style = {this.state.description !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {""}
                underlineColorAndroid= {'transparent'}
                value={this.state.description}
                onChangeText={(text) =>{
                  this.setState({ description: text})
                  setTimeout(()=>this.checkValidity(),500)
                  }}/>
           

              <Text style = {orderFormStyles.subHeader} >No of Pieces</Text>  
              <TextInput style = {this.state.nPieces !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {""}
                underlineColorAndroid= {'transparent'}
                value={this.state.nPieces}
                onChangeText={(text) =>{
                   this.setState({ nPieces: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>

              <Text style = {orderFormStyles.subHeader} >Value</Text>  
              <TextInput style = {this.state.value !== ""? orderFormStyles.textInput: orderFormStyles.textInputBad}
                placeholderTextColor = {'grey'}
                placeholder = {""}
                underlineColorAndroid= {'transparent'}
                value={this.state.value}
                onChangeText={(text) =>{
                   this.setState({ value: text})
                   setTimeout(()=>this.checkValidity(),500)
                   }}/>


              <Text style = {orderFormStyles.subHeader} >Is this item hazardous?</Text>  
              <Picker
                selectedValue={this.state.hazardous}
                style = {this.state.hazardous !== ""? orderFormStyles.picker: orderFormStyles.pickerBad}
                onValueChange={(itemValue, itemIndex) => {
                  this.setState({ hazardous: itemValue })
                  setTimeout(()=>this.checkValidity(),500)
                }}>
                <Picker.Item label="Yes" value="Yes" />
                <Picker.Item label="No" value="No" />
                <Picker.Item label="" value="" />
              </Picker>

              <Text style = {orderFormStyles.subHeader} >Would you like to insure</Text>  
              <Picker
                selectedValue={this.state.insure}
                style = {this.state.insure !== ""? orderFormStyles.picker: orderFormStyles.pickerBad}
                onValueChange={(itemValue, itemIndex) => {
                  this.setState({ insure: itemValue })
                  setTimeout(()=>this.checkValidity(),500)
                }}>
                <Picker.Item label="Yes" value="Yes" />
                <Picker.Item label="No" value="No" />
                <Picker.Item label="" value="" />
              </Picker>

              <Text style = {orderFormStyles.subHeader} >Passport</Text>  
              <Picker
                selectedValue={this.state.passportNo}
                style = {this.state.passportNo !== ""? orderFormStyles.picker: orderFormStyles.pickerBad}
                onValueChange={(itemValue, itemIndex) => {
                  this.setState({ passportNo: itemValue })
                  setTimeout(()=>this.checkValidity(),500)
                }}>
                <Picker.Item label="Yes" value="Yes" />
                <Picker.Item label="No" value="No" />
                <Picker.Item label="" value="" />
              </Picker> 

              <Text style = {orderFormStyles.subHeader} >IRS/ EIN No.</Text>  
              <Picker
                selectedValue={this.state.IRSNo}
                style = {this.state.IRSNo !== ""? orderFormStyles.picker: orderFormStyles.pickerBad}
                onValueChange={(itemValue, itemIndex) => {
                  this.setState({ IRSNo: itemValue })
                  setTimeout(()=>this.checkValidity(),500)
                }}>
                <Picker.Item label="Yes" value="Yes" />
                <Picker.Item label="No" value="No" />
                <Picker.Item label="" value="" />
              </Picker>

              

               <TouchableOpacity 
                disabled = {this.state.disableSubmit}
                style = {this.state.disableSubmit === false? orderFormStyles.modalButton: orderFormStyles.modalDisabledButton}
                onPress = {() => this.onClickSubmit()}>
                <Text style = {orderFormStyles.buttonText}>SUBMIT</Text>
              </TouchableOpacity>

              </View>

             

              
          </ScrollView>
    
      )
  }
}




  